var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0741 24.1391C14.7555 24.1392 17.3603 23.2444 19.4757 21.5965L27.4567 29.5787C28.0529 30.1546 29.0029 30.138 29.5787 29.5417C30.1404 28.9601 30.1404 28.0379 29.5787 27.4563L21.5978 19.4741C25.6864 14.2102 24.7343 6.62787 19.4711 2.53861C14.2079 -1.55065 6.62687 -0.598398 2.53823 4.66558C-1.55041 9.92956 -0.598308 17.5118 4.66487 21.6011C6.78379 23.2474 9.3909 24.1405 12.0741 24.1391ZM5.66144 5.65768C9.20308 2.11544 14.9452 2.11538 18.4869 5.65755C22.0286 9.19973 22.0287 14.9427 18.487 18.485C14.9454 22.0272 9.20327 22.0273 5.66157 18.4851L5.66144 18.485C2.1198 14.9686 2.09894 9.24654 5.61477 5.70436L5.66144 5.65768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ff0d1483f2d8e8efcd0ac89c25858863.svg";
export { ForwardRef as ReactComponent };